<template>
  <div>
    <div class="container">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card
          elevation="24"
          max-width="400"
          class="mx-auto"
          color="#00BB2D"
          dark
          raised
        >
          <v-card-title class="headline layout justify-center"
            >Lector de Código QR
            <p class="error">{{ error }}</p>

            <p class="decode-result">
              Último resultado: <b>{{ result }}</b>
            </p></v-card-title
          >
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <StreamBarcodeReader
                  @decode="onDecode"
                  @error="onInit"
                  @loaded="onLoaded"
                ></StreamBarcodeReader>
                <!-- <qrcode-stream @decode="onDecode" @init="onInit" /> -->
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
//import { QrcodeStream } from "vue-qrcode-reader";

export default {
  // components: { QrcodeStream },
  components: { StreamBarcodeReader },

  data() {
    return {
      result: "",
      error: "",
    };
  },

  methods: {
    onDecode(result) {
      this.result = result;
    },
    onLoaded() {
      console.log("load");
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: necesitas permiso de acceso a la cámara";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no hay una cámara en este dispositivo";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: requiere un contexto seguro (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: Está la cámara ya en uso?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: la cámara instalada no es apropiada";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API no está soportada por este navegador";
        } else if (error.name === "InsecureContextError") {
          this.error =
            "ERROR: El acceso a la Cámara sólo se permite en un contexto seguro. Use HTTPS o localhost en lugar de HTTP.";
        } else {
          this.error = `ERROR: Error de Cámara (${error.name})`;
        }
      }
    },
  },
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>
